import * as React from 'react'
import { navigate } from 'gatsby'
import HeaderMol from '../../../molecules/header'
import '../../../../.config/css'
import { Header, Segment, Button, Image } from 'semantic-ui-react'
import img from './header.png'
import bg from './bg.gif'
import stamp from './stamp.jpg'
import Helmet from 'react-helmet'
import style from './index.module.css'

export default class LayoutOrg extends React.Component<{ active: string }, {}> {
  handleClick = (page: string) => {
    navigate('/' + page)
  }
  render() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          margin: 0,
          width: '100%',
        }}
      >
        <Helmet>
          <title>滋賀中国語教室 日中文化サロン守山</title>
          <meta
            name="google-site-verification"
            content="AIXw6z9YOE4agaazagJd4VrGxkYgdOOizi6Q9n811dg"
          />
        </Helmet>
        <div style={{ width: '100%', position: 'fixed', zIndex: 9999 }}>
          <Segment style={{ backgroundImage: `url(${img})` }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <Header
                  as="h1"
                  style={{ padding: 10, marginBottom: 0 }}
                  color="green"
                >
                  <p
                    onClick={() => {
                      navigate('/')
                    }}
                    style={{ display: 'flex', flexWrap: 'wrap', margin: 0 }}
                  >
                    滋賀中国語教室（日中文化サロン）
                  </p>
                </Header>
                <div
                  style={{
                    padding: '0 10px 10px',
                    wordBreak: 'break-all',
                  }}
                >
                  <a
                    href="https://shiga-chinese-class.netlify.app/"
                    target="_blank"
                    rel="noopener"
                  >
                    https://shiga-chinese-class.netlify.app/
                  </a>
                </div>
              </div>
              <div style={{ paddingRight: 10, flexShrink: 0 }}>
                <Image src={stamp} size="tiny" />
              </div>
            </div>
            <HeaderMol
              items={[
                { ホーム: '' },
                { '研究/出版': 'research' },
                { 'メルマガ/まぐまぐ': 'magazine' },
                { 'ラジオ/出演記事': 'article' },
                { '薬膳/茶芸': 'tea' },
                { '翻訳（実務・文芸）': 'translate' },
              ]}
              onClick={this.handleClick}
              active={this.props.active}
            />
          </Segment>
        </div>
        <div
          style={{
            display: 'flex',
            backgroundImage: `url(${bg})`,
            minHeight: '100vh',
          }}
        >
          <div className={style.content} style={{ flex: 1 }}>
            <div style={{ height: '101%', backgroundImage: `url(${bg})` }}>
              {this.props.children}
            </div>
          </div>
        </div>
        <br />
      </div>
    )
  }
}
